import {
    FormatBoldRounded,
    FormatItalicRounded,
    FormatUnderlinedRounded,
    StrikethroughSRounded,
} from '@mui/icons-material';
import MarkButton from './MarkButton';
import { useTranslation } from 'react-i18next';

function FormatButtons() {
    const { t } = useTranslation();

    return (
        <>
            <MarkButton
                format="bold"
                icon={<FormatBoldRounded fontSize="small" />}
                tooltip={t('Bold')}
            />
            <MarkButton
                format="italic"
                icon={<FormatItalicRounded fontSize="small" />}
                tooltip={t('Italic')}
            />
            <MarkButton
                format="underline"
                icon={<FormatUnderlinedRounded fontSize="small" />}
                tooltip={t('Underline')}
            />

            <MarkButton
                format="strikethrough"
                icon={<StrikethroughSRounded fontSize="small" />}
                tooltip={t('Strikethrough')}
            />
        </>
    );
}

export default FormatButtons;
